import type { ClientDetailPass } from '@/types';
import { getPassMeta } from '@/shared/lib/client';

export interface PassBuckets {
  active: ClientDetailPass[];
  future: ClientDetailPass[];
  past: ClientDetailPass[];
}

export const bucketPasses = (passes: ClientDetailPass[]): PassBuckets => {
  const buckets: PassBuckets = { active: [], future: [], past: [] };
  for (const pass of passes) {
    const meta = getPassMeta(pass);
    if (!meta) continue;
    if (meta.isActive) buckets.active.push(pass);
    else if (meta.isFuture) buckets.future.push(pass);
    else if (meta.isExpired || meta.isOutOfCredits) buckets.past.push(pass);
  }
  return buckets;
};
